import { useState } from 'react';
import { useWorkspace } from '../hooks/useWorkspace';
import { MarketplaceCard, TeamBundleCard } from '../components/Selectors';
import { installBotTemplate, installTeamTemplate } from '../services/api';
import AgentBuilder from './AgentBuilder';

// BB-2 (docs/build_bot_platform.md §4): the Agent Builder lives in the
// Marketplace module — the agent-bot-builder platform manifest's home
// (module_slug: marketplace). The 12-module nav stays data-driven; this is an
// in-module surface, not a 13th route.

export default function Marketplace() {
  const state = useWorkspace();
  const [showBuilder, setShowBuilder] = useState(false);

  return (
    <div className="page">
      <header className="page-header hero-header">
        <div>
          <span className="eyebrow">Marketplace</span>
          <h1>Add capability, not complexity.</h1>
          <p>Install one specialist or a complete working team — or draft your own from a description.</p>
        </div>
        <div className="date-card">
          <small>Installed</small>
          <b>{state.installedTemplates.length} templates</b>
          <span>Ready for configuration</span>
        </div>
      </header>

      <section className="panel builder-entry">
        <div>
          <span className="eyebrow">Agent Builder</span>
          <h3>Need something the catalog doesn't cover?</h3>
          <p>
            Describe the specialist or team you need, review the drafted manifest, then install —
            nothing is created until you approve the draft.
          </p>
        </div>
        <button
          className="button primary"
          onClick={() => setShowBuilder((current) => !current)}
        >
          {showBuilder ? 'Close builder' : 'Build a custom agent'}
        </button>
      </section>

      {showBuilder && <AgentBuilder />}

      <div className="market-grid">
        {state.marketplace.map((item) => item.type === 'team'
          ? <TeamBundleCard
              key={item.id}
              item={item}
              installed={state.installedTemplates.includes(item.id)}
              onInstall={() => installTeamTemplate(item.id)}
            />
          : <MarketplaceCard
              key={item.id}
              item={item}
              installed={state.installedTemplates.includes(item.id)}
              onInstall={() => installBotTemplate(item.id)}
            />)}
      </div>
    </div>
  );
}
